import { IntlFormatters } from 'react-intl';
import * as yup from 'yup';
import { appMessages } from '../translations';
import { messages as formMessages } from './components/form/CheckpointForm.translations';

const MAX_NAME_LENGTH = 150;
const MAX_DESCRIPTION_LENGTH = 200;
const MAX_QR_CODE_ID_LENGTH = 36;

export const checkpointSchema = (formatMessage: IntlFormatters['formatMessage']) => {
  const descriptionField = formatMessage(formMessages['checkpoint.form.description']);
  const qrCodeIdField = formatMessage(formMessages['checkpoint.form.identity']);
  const nameField = formatMessage(formMessages['checkpoint.form.name']);
  const orderField = formatMessage(formMessages['checkpoint.form.order']);

  return yup.object().shape({
    description: yup.string()
      .optional()
      .max(MAX_DESCRIPTION_LENGTH, formatMessage(appMessages['app.maxLength'],
        {
          fieldName: descriptionField,
          maxLength: MAX_DESCRIPTION_LENGTH
        })),
    name: yup.string()
      .required(formatMessage(appMessages['app.required'], {
        fieldName: nameField
      }))
      .max(MAX_NAME_LENGTH, formatMessage(appMessages['app.maxLength'],
        {
          fieldName: nameField,
          maxLength: MAX_NAME_LENGTH
        }))
      .matches(/\S/, formatMessage(appMessages['app.nonBlank'], {
        fieldName: nameField
      })),
    order: yup.number()
      .optional()
      // Allow empty string so we can clear the input
      .transform((value, originalValue) => originalValue === '' ? undefined : value)
      .typeError(formatMessage(appMessages['app.isNumber'], {
        fieldName: orderField
      })),
    qrCodeId: yup.string()
      .optional()
      .nullable()
      .max(MAX_QR_CODE_ID_LENGTH, formatMessage(appMessages['app.maxLength'],
        {
          fieldName: qrCodeIdField,
          maxLength: MAX_QR_CODE_ID_LENGTH
        }))
  });
};
